import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Icon from "@Shared/components/general/fa-icon";
import { mapGetters } from "vuex";
import MaterialInput from "@Shared/components/inputs/material-input";
import ESignTemplateSelectContentTemplate from "@Broker/@HandlebarsTemplates/clients/applications/modals/_e-sign-template-select-content.hbs";
import Select2 from "@Shared/components/inputs/select2";
import { cloneDeep, filter, values } from "lodash";
import { defineComponent } from "@vue/composition-api";
import { CURRENT_APPLICATION } from "../../../store/application-getters";
export default defineComponent({
  name: "ESignSelectTemplatePage",
  components: {
    Select2,
    MaterialInput,
    Icon
  },
  props: {
    templates: {
      type: Object,
      required: true
    },
    signers: {
      type: Object,
      default: () => ({})
    },
    currentTemplateData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      fileNameMaxLength: 35,
      editing: {
        title: false,
        message: false
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ApplicationStore", [CURRENT_APPLICATION])), {}, {
    options() {
      return {
        closeOnSelect: true,
        templateResult: this.formatResult,
        placeholder: this.$t("e-sign-package.actions.chooseATemplate"),
        dropdownCssClass: "select-esign-template",
        dropdownParent: "#e-sign-modal-wrapper"
      };
    },
    signersValues() {
      return _Object$values(this.signers);
    },
    amountOfSignerRoles() {
      return this.currentTemplateData.signerRoles.length;
    },
    amountOfApplicationSigners() {
      return this.signersValues.length;
    },
    allTemplates() {
      return values(this.templates);
    },
    completeTemplates() {
      return filter(this.templates, template => template.complete);
    },
    isValid() {
      return true;
    },
    matchableTemplateSelected() {
      return this.amountOfSignerRoles >= this.amountOfApplicationSigners;
    },
    emailMessage() {
      return this.currentTemplateData.isApplicationIdIncluded === true ? `${this.$t("e-sign-package.applicationId")}: ${this.CURRENT_APPLICATION.applicationId}. ${this.currentTemplateData.message}` : `${this.currentTemplateData.message}`;
    }
  }),
  watch: {
    isValid: {
      handler(value) {
        this.$emit("valid", value);
      },
      immediate: true
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.select.initSelect2();
    });
  },
  methods: {
    formatData(data) {
      data = cloneDeep(data);
      return data && _mapInstanceProperty(data).call(data, ref => _objectSpread(_objectSpread({}, ref), {}, {
        id: ref.eSignTemplateId,
        text: ref.name
      }));
    },
    formatResult(state) {
      var _state$signerRoles;
      return $(ESignTemplateSelectContentTemplate(_objectSpread(_objectSpread({}, state), {}, {
        signerTypesText: this.$tc("e-sign-package.signerType", (_state$signerRoles = state.signerRoles) == null ? void 0 : _state$signerRoles.length)
      })));
    },
    updateIsApplicationIdIncluded() {
      this.$emit("update-prefix-appid", this.shouldIncludeApplicationId);
    },
    handleSelectTemplate({
      eSignTemplateId
    }) {
      const templateSelected = this.templates[eSignTemplateId];
      const {
        name,
        description,
        complete,
        expired,
        templateId,
        files,
        message,
        title,
        subject,
        signerRoles,
        isApplicationIdIncluded
      } = templateSelected;
      this.$emit("template-select", {
        eSignTemplateId,
        name,
        description,
        files,
        title,
        message,
        subject,
        signerRoles,
        complete,
        expired,
        templateId,
        isApplicationIdIncluded
      });
    },
    clearTemplate() {
      this.$emit("template-select", {
        eSignTemplateId: "",
        name: "",
        description: null,
        files: [],
        title: null,
        message: null,
        subject: null,
        signerRoles: [],
        complete: "",
        expired: "",
        templateId: "",
        isApplicationIdIncluded: false
      });
    },
    editTemplateData(field, value) {
      this.editing[field] = value;
    }
  }
});